import React from 'react'
import { observer } from 'mobx-react-lite'

import {
  ANALYTICS_EVENTS,
  Drawer,
  useGlobalCopyStore,
  useEvent,
  useTransactionStore,
  useGlobalUiStore,
} from '../../common'
import { Transaction } from '../../core'
import { TransactionDetails, TransactionList } from '../../transactions'

const copy = {
  title: 'Transaction List',
}

interface TrendsDrawerProps {
  categoryGuid: string
  dateRange: {
    start: Date
    end: Date
  }
  isOpen: boolean
  onClose: () => void
}

const TrendsDrawer: React.FC<TrendsDrawerProps> = ({
  categoryGuid,
  dateRange,
  isOpen,
  onClose,
}) => {
  const { onEvent } = useEvent()
  const { selectedAccountGuids: accounts } = useGlobalUiStore()
  const { common: commonCopy } = useGlobalCopyStore()
  const { setFilter, sortedTransactions } = useTransactionStore()

  const [guid, setGuid] = React.useState('')
  const transaction = React.useMemo(
    () => sortedTransactions.find((t) => t.guid === guid),
    [guid, sortedTransactions],
  )

  React.useEffect(() => {
    setFilter({
      accounts,
      dateRange,
      custom: (t: Transaction) =>
        categoryGuid === '' ||
        categoryGuid === t.category_guid ||
        categoryGuid === t.top_level_category_guid,
      showSplits: Boolean(categoryGuid),
    })
  }, [accounts, categoryGuid, dateRange])

  React.useEffect(() => onEvent(ANALYTICS_EVENTS.TRENDS_VIEW_TRANSACTIONS), [])

  const handleClose = () => {
    setGuid('')
    onClose()
  }

  return (
    <Drawer
      ariaLabelClose={commonCopy.close_aria}
      isOpen={isOpen}
      onClose={handleClose}
      title={copy.title}
    >
      {transaction && <TransactionDetails transaction={transaction} />}
      {!transaction && <TransactionList onClick={setGuid} />}
    </Drawer>
  )
}

export default observer(TrendsDrawer)
